import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { GENZ_SERIES } from './genzContent';

export const GenZOverview = ({ dark = true }) => {
  const [open, setOpen] = useState(false);
  const text = dark ? 'text-white/85' : 'text-slate-700';
  return (
    <div>
      <p className={`font-body text-base md:text-lg leading-relaxed ${text}`} data-testid="genz-intro">
        {GENZ_SERIES.intro}
      </p>
      <div
        className={`grid transition-[grid-template-rows,opacity] duration-500 ${open ? 'grid-rows-[1fr] opacity-100 mt-6' : 'grid-rows-[0fr] opacity-0'}`}
        data-testid="genz-overview"
        aria-hidden={!open}
      >
        <div className="overflow-hidden">
          <h3 className={`font-heading text-xl font-semibold mb-4 ${dark ? 'text-brand-accent' : 'text-brand-primary'}`}>
            {GENZ_SERIES.overviewTitle}
          </h3>
          <div className={`space-y-4 font-body text-sm md:text-base leading-relaxed ${text}`}>
            {GENZ_SERIES.overview.map((p, i) => <p key={i}>{p}</p>)}
          </div>
        </div>
      </div>
      <button
        onClick={() => setOpen(!open)}
        className={`mt-4 inline-flex items-center gap-1.5 font-body font-semibold text-sm ${dark ? 'text-brand-accent' : 'text-brand-primary'} hover:underline underline-offset-4`}
        aria-expanded={open}
        data-testid="genz-read-more-button"
      >
        {open ? 'Read Less' : 'Read More'}
        <ChevronDown className={`h-4 w-4 transition-transform duration-300 ${open ? 'rotate-180' : ''}`} />
      </button>
    </div>
  );
};
